import React from 'react'
import { View, TouchableOpacity, Text, StyleSheet} from 'react-native'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import { responsiveFontSize, responsiveHeight, responsiveWidth } from 'react-native-responsive-dimensions'
import colors from '../styles/colors'
import MyText from './MyText'

export default function ViewCart({numCart, total, navigation}){

    return numCart > 0 &&(
        <TouchableOpacity style={styles.container} onPress={()=>{navigation.navigate('Cart')}}>
            <View style={{flexDirection: 'row', width: '70%', justifyContent: 'space-around'}}>
                <View>
                    <View style={styles.containerTextNumCart}>
                        <MyText style={styles.numCartBtn}>{numCart}</MyText>
                    </View>
                    <MaterialCommunityIcons name="cart-outline" size={24} color="white"/>
                </View>
                <MyText style={styles.txtCart}>Ver Carrinho</MyText>
            </View>
            <MyText style={styles.priceCart}>R${total.toFixed(2)}</MyText>
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        width: '100%',
        height: responsiveHeight(8),
        backgroundColor: colors.red,
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: responsiveWidth(5)
    },
    containerTextNumCart: {
        backgroundColor: 'white',
        position: 'absolute',
        width: '60%',
        height: '60%',
        borderRadius: 100,
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        left: 15,
        bottom: 15
    }, 
    numCartBtn: {
        color: colors.red,
        fontSize: responsiveFontSize(1.2),
        fontWeight: 'bold'
    },
    txtCart: {
        fontSize: responsiveFontSize(1.8),
        marginLeft: responsiveWidth(4),
        alignSelf: 'center',
        fontWeight: 'bold',
        color: 'white'
    },
    priceCart: {
        color: 'white',
        fontSize: responsiveFontSize(1.9),
        fontWeight: 'bold'
    }
})